/** Project-level material/consumable unit choices always available in addition to master data. */
export const PROJECT_LEVEL_MATERIAL_UNITS = ['tubes', 'pack'];

/**
 * Merge API/master unit rows with project-level defaults (deduped, case-insensitive).
 * @param {Array<{ unit?: string }|string>} apiUnits
 * @returns {Array<{ unit: string }>}
 */
export function mergeProjectMaterialUnits(apiUnits = []) {
  const seen = new Set();
  const merged = [];

  (Array.isArray(apiUnits) ? apiUnits : []).forEach((item) => {
    const unit = typeof item === 'string' ? item : item?.unit;
    const normalized = String(unit || '').trim();
    if (!normalized) return;
    const key = normalized.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    merged.push(typeof item === 'object' && item != null ? { ...item, unit: normalized } : { unit: normalized });
  });

  PROJECT_LEVEL_MATERIAL_UNITS.forEach((unit) => {
    const key = unit.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    merged.push({ unit });
  });

  return merged.sort((a, b) =>
    String(a.unit || '').localeCompare(String(b.unit || ''), undefined, { sensitivity: 'base' })
  );
}

/** Options shape for SimpleSelect / similar `{ value, label }` dropdowns. */
export function buildProjectMaterialUnitSelectOptions(apiUnits = []) {
  return mergeProjectMaterialUnits(apiUnits).map((item) => ({
    value: item.unit,
    label: item.unit || '',
  }));
}
